import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { ActivatedRoute } from '@angular/router';
import { CentersCentersService } from 'src/app/services/centers-services/centers-centers-service/centers-centers.service';
import { EMPTY, Subscription } from 'rxjs';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { catchError } from 'rxjs/internal/operators/catchError';
import { tap } from 'rxjs/internal/operators/tap';

@Component({
  selector: 'app-centers-center-schedule-dashboard',
  templateUrl: './centers-center-schedule-dashboard.component.html',
  styleUrls: ['./centers-center-schedule-dashboard.component.scss']
})
export class CentersCenterScheduleDashboardComponent implements OnInit, OnDestroy {

  schedule;
  getCenterScheduleInfoSubscription: Subscription;

  constructor(private activatedRoute: ActivatedRoute,
              private centersCentersService: CentersCentersService,
              private headerBreadcrumbService: HeaderBreadcrumbService,
              private snackbarService: SnackBarService) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.getScheduleInfo();
  }

  private getScheduleInfo() {
    const internalId = this.activatedRoute.snapshot.params['scheduleid'];
    this.getCenterScheduleInfoSubscription = this.centersCentersService.getCenterScheduleInfo(internalId).pipe(
      tap(o => this.schedule = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private setBreadcrumb() {
    const centerid = this.activatedRoute.snapshot.params['centerid'];
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-calendar-day', 'schedule-page.new schedule', '/center/' + centerid, [new BRoute('stores-page.store locator', '/centers'), new BRoute('stores-page.store detail', '/center/' + centerid), new BRoute('schedule-page.schedule detail')]));
  }

  ngOnDestroy() {
    if (this.getCenterScheduleInfoSubscription) { this.getCenterScheduleInfoSubscription.unsubscribe(); }
  }
}
